module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueMiniParcours_LRP.8dbe1ab3.png";